export const LIST_TRIPS_SLICE = "listTrips";
export interface IListTripsSlice {
  isGot: boolean;
  dateFrom: string;
  status: string | null;
  trips: ITrip[];
}

export interface ITrip {
  _id: string;
  name: string;
  nameNoAccent: string;
  numberOfDate: number;
  endDate: string;
  numberOfNight: number;
  status: string;
  isNightDeparture: boolean;
  departureDate: Date;
  departureLunaDate: Date;
}
export const TRIPS_URL = "/trips";
export interface ITripPayload {
  name: string;
  numberOfDate: number;
  numberOfNight: number;
  isNightDeparture: boolean;
  departureDate: string | Date;
}
export interface IGetListTripPayload {
  dateFrom: string;
  status: string | null;
  data: ITrip[];
}
